import React from 'react';

/* =============================================================
 *  HaleBrand — official wordmark block
 *  Bold condensed wordmark on Hale red background. Matches the
 *  thehale.co brand identity (red rectangular block, black
 *  industrial typography).
 *  Brand palette:
 *    primary red:    #E63946  (Hale red)
 *    red-deep:       #C9192C  (hover)
 *    ink:            #0B0B0B  (wordmark + text on red)
 *    text-on-red:    #0B0B0B
 * ===========================================================*/

export const HALE_RED      = '#E63946';
export const HALE_RED_DEEP = '#C9192C';
export const HALE_INK      = '#0B0B0B';

export function HaleWordmark({ size = 'md', subtitle = null, className = '' }) {
  const dims = {
    sm: { px: 'px-2.5 py-1',   text: 'text-base',  tracking: 'tracking-[0.04em]', sub: 'text-[8px]' },
    md: { px: 'px-3 py-1.5',   text: 'text-xl',    tracking: 'tracking-[0.04em]', sub: 'text-[9px]' },
    lg: { px: 'px-4 py-2',     text: 'text-3xl',   tracking: 'tracking-[0.04em]', sub: 'text-[10px]' },
    xl: { px: 'px-6 py-3',     text: 'text-5xl',   tracking: 'tracking-[0.04em]', sub: 'text-[11px]' },
  }[size] || {};
  return (
    <div className={`inline-flex flex-col items-start ${className}`} data-testid="hale-wordmark">
      <div
        className={`${dims.px} bg-[${HALE_RED}] inline-flex items-center`}
        style={{ backgroundColor: HALE_RED, lineHeight: 1 }}
      >
        <span
          className={`${dims.text} ${dims.tracking} font-black uppercase`}
          style={{
            color: HALE_INK,
            fontFamily: '"Archivo Black", "Helvetica Neue", Impact, sans-serif',
            letterSpacing: '0.04em',
            fontStretch: 'condensed',
          }}
        >
          HALE
        </span>
      </div>
      {subtitle && (
        <p className={`${dims.sub} font-bold uppercase tracking-[0.2em] mt-1.5 text-[#4B5563]`}>
          {subtitle}
        </p>
      )}
    </div>
  );
}

/** Small inline pill version for use in nav bars / breadcrumb strips. */
export function HalePill({ children = 'Hale Partnership', testid = 'hale-pill' }) {
  return (
    <span
      className="inline-flex items-center gap-1.5 px-2 py-1 rounded-sm"
      style={{ backgroundColor: HALE_RED }}
      data-testid={testid}
    >
      <span
        className="text-[10px] font-black uppercase tracking-[0.18em]"
        style={{ color: HALE_INK, fontFamily: '"Archivo Black", Impact, sans-serif' }}
      >
        HALE
      </span>
      <span className="text-[10px] font-bold uppercase tracking-[0.15em] text-[#0B0B0B]/80">
        {children}
      </span>
    </span>
  );
}
